export default __webpack_public_path__ + "static/Marcel-28ef972173c5e7ef04aff0c9b54dc4d5.png";